// Stamps every .table cell with a data-label taken from its column header,
// so the mobile stylesheet can render each row as a labeled card instead of
// a table that needs horizontal scrolling — see the ".table" rules under
// the max-width:680px query in afagh_terminal.css. Runs generically over
// every table on the page rather than requiring each view to set labels
// itself, and re-runs on Turbo navigation/frame/stream updates since those
// can inject fresh rows without labels.
function labelTables() {
  document.querySelectorAll("table.table").forEach((table) => {
    const headers = [...table.querySelectorAll(":scope > thead > tr > th")].map((th) => th.textContent.trim())
    if (!headers.length) return

    table.querySelectorAll(":scope > tbody > tr").forEach((row) => {
      row.querySelectorAll(":scope > td").forEach((td, index) => {
        if (headers[index]) td.setAttribute("data-label", headers[index])
      })
    })
  })
}

let scheduled = false
function schedule() {
  if (scheduled) return
  scheduled = true
  requestAnimationFrame(() => {
    scheduled = false
    labelTables()
  })
}

document.addEventListener("turbo:load", schedule)
document.addEventListener("turbo:frame-load", schedule)
document.addEventListener("turbo:render", schedule)

new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true })
